<template>
  <div>
    <h4 class="header-title mt-0">Uued kliendid</h4>
    <table id="clients" class="table table-sm table-centered table-sticky table-hover mb-0">
      <thead>
        <tr>
          <th>Nimi</th>
          <th>Reg. kood</th>
          <th>Haldur</th>
          <th>Staatus</th>
          <th>Loodud</th>
        </tr>
      </thead>
      <tbody>
      <tr v-for="client in clients" @click="clientDetails(client)" style="cursor: pointer" class="client">
        <td><a tabindex="0" @click="clientDetails(client)">{{client.name}}</a></td>
        <td>{{client.regCode}}</td>
        <td>{{client.managerName}}</td>
        <td>
          <span :class="'badge badge-lg badge-' + statusStyleClass(client.statusCode)">{{client.status}}</span>
        </td>
        <td>{{client.createdAt | formatDate }}</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import gateway from '@/services/gateway'
  import ClientStatusStyleClass from '../../mixins/ClientStatusStyleClass'

  export default {
    mixins: [ClientStatusStyleClass],
    data() {
      return {
        clients: []
      }
    },
    methods: {
      clientDetails(client) {
        this.$store.commit('client', {id: client.id, name: client.name})
        this.$router.push('/client')
      }
    },
    watch: {
      '$store.state.client'(client) {
        if (client)
          this.$router.push('/client')
      }
    },
    created() {
      gateway.get('/dashboard/clients').then(r => this.clients = r.data)
    }
  }
</script>
